var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "26px",
    height: "26px",
    viewBox: "0 0 89.387 96.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13177",
    d: "M0 46.694C0 83.5 7.888 91.389 44.694 91.389S89.387 83.5 89.387 46.694 81.5 2 44.694 2 0 9.889 0 46.694zm7.449 0c0 9.032.494 15.78 1.63 20.895 1.118 5.03 2.756 8.01 4.733 9.987s4.957 3.615 9.987 4.733c5.114 1.137 11.863 1.63 20.895 1.63s15.78-.494 20.895-1.63c5.03-1.118 8.01-2.756 9.987-4.733s3.615-4.957 4.733-9.987c1.137-5.115 1.63-11.863 1.63-20.895 0-2.678-.044-5.155-.134-7.449H7.583a188.741 188.741 0 0 0-.134 7.449zm.667-14.9h73.155a56.524 56.524 0 0 0-.963-6c-1.118-5.03-2.756-8.01-4.733-9.987s-4.957-3.615-9.987-4.733c-5.114-1.137-11.863-1.63-20.895-1.63s-15.78.494-20.895 1.63c-5.03 1.118-8.01 2.756-9.987 4.733S10.2 20.77 9.079 25.8a56.568 56.568 0 0 0-.963 6z",
    transform: "translate(0 5.449)",
    style: {
      fill: "#abafd1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13178",
    d: "M8.724 15a3.725 3.725 0 0 0 0 7.449H19.9a3.725 3.725 0 0 0 0-7.449z",
    transform: "translate(13.622 40.868)",
    style: {
      fill: "#6610f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13179",
    d: "M8.724 19a3.725 3.725 0 0 0 0 7.449H19.9a3.725 3.725 0 0 0 0-7.449z",
    transform: "translate(13.622 51.766)",
    style: {
      fill: "#6610f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13180",
    d: "M14 18.725A3.724 3.724 0 0 1 17.724 15H28.9a3.725 3.725 0 0 1 0 7.449H17.724A3.724 3.724 0 0 1 14 18.725z",
    transform: "translate(38.143 40.868)",
    style: {
      fill: "#6610f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13181",
    d: "M17.724 19a3.725 3.725 0 0 0 0 7.449H28.9a3.725 3.725 0 0 0 0-7.449z",
    transform: "translate(38.143 51.766)",
    style: {
      fill: "#6610f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13182",
    d: "M10.724 0A3.725 3.725 0 0 0 7 3.725v14.9a3.724 3.724 0 1 0 7.449 0v-14.9A3.725 3.725 0 0 0 10.724 0z",
    transform: "translate(19.071)",
    style: {
      fill: "#6610f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13183",
    d: "M18.724 0A3.724 3.724 0 0 0 15 3.725v14.9a3.724 3.724 0 1 0 7.449 0v-14.9A3.724 3.724 0 0 0 18.724 0z",
    transform: "translate(40.867)",
    style: {
      fill: "#6610f2"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.94d1f6fb62f06d4ef42c1b57a893ad1e.svg";
export { ForwardRef as ReactComponent };